<template>
    <div>
        <div class="vertical-center">
            <div class="col-lg-offset-12 col-lg-12 col-md-offset-12 col-md-12 col-sm-12 col-xs-12">
                <div class="panel panel-default country-select-panel text-center">
                    <div class="panel-heading">
                        <h3>Survey</h3>
                    </div>
                    <div class="panel-body">
                        <form id="login-form">
                            <input type="hidden" name="_csrf"
                                   value="0sg7OhAxLL4HUMSN8uKEjcg2GqABzcjnUrOykkHgmx-UkUNrZntK9F9kifW4jubMoVJRk3OJvp5i3sWqAoj-eQ==">
                            <div style="padding-bottom: 35px;" class="col-md-12">
                                <div class="col-md-offset-1 col-md-10">
                                    <div class="form-group field-client-name required">
                                        <input  v-model="code"
                                                type="text"
                                                class="input__field input__field--hoshi user-icon-input"
                                                placeholder="Enter code"
                                                style="border-bottom:1px solid lightgray;"
                                        >

                                    </div>
                                </div>
                                <div class="form-group field-client-card">
                                    <div class="help-block"></div>
                                </div>
                                <div style="margin-top: 20px;" class="col-md-12 col-xs-12 col-sm-12">
                                    <button v-on:click="goCode()" type="button" class="btn btn-primary btn-sm">SEND</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import Vue from "vue";

    export default {
        name: 'index',
        data() {
            return {
                code: ''
            }
        },
        methods: {
            goCode() {
                Vue.prototype.$http({
                    url: `${process.env.VUE_APP_API_URL}/survey/go`, method: 'GET', params: {
                        uid: this.code
                    }
                })
                    .then(resp => {
                        const data = resp.data;

                        if(data.success === true) {
                            window.location.href = `/r/${this.code}`
                        } else {
                            this.$swal({
                                title: 'Error',
                                text: 'Code not found. Try another code',
                                icon: 'error',
                                confirmButtonColor: '#f93e56',
                                confirmButtonText: 'Close'
                            });
                        }
                    })
                    .catch(() => {
                        this.$swal({
                            title: 'Error',
                            text: 'Error while proccesing request. Try again later',
                            icon: 'error',
                            confirmButtonColor: '#f93e56',
                            confirmButtonText: 'Close'
                        });
                    })
            }
        }
    }
</script>

<style scoped>

    body {
        color: white;
    }

    .container {
        height: 200px;
        position: relative;
        border: 3px solid green;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .panel {
        border: 1px solid black;
        background: #fffdfd;
    }

    .panel-heading {
        border-radius: 0;
    }
</style>